import { supabase } from '@/db/client';

import type { Profile, SignInResult } from '../auth.types';

export const authService = {
  async signInWithPassword(email: string, password: string): Promise<SignInResult> {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) return { ok: false, message: error.message };
    return { ok: true, message: 'Signed in.' };
  },

  async signUp(email: string, password: string, fullName?: string): Promise<SignInResult> {
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: { data: { full_name: fullName ?? email } },
    });
    if (error) return { ok: false, message: error.message };
    return { ok: true, message: 'Account created. Check your email to verify.' };
  },

  async signInWithMagicLink({ email, redirectTo }: { email: string; redirectTo: string }): Promise<void> {
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: redirectTo },
    });
    if (error) throw new Error(error.message);
  },

  async signInWithGoogle(): Promise<void> {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}/auth/callback` },
    });
    if (error) throw new Error(error.message);
  },

  async signOut(): Promise<void> {
    await supabase.auth.signOut();
  },

  async getProfile(userId: string): Promise<Profile | null> {
    const { data, error } = await supabase
      .from('profiles')
      .select('id, email, full_name, phone, role, active, brickflow_user_email, created_at, updated_at')
      .eq('id', userId)
      .maybeSingle();
    if (error ?? !data) return null;
    return data as Profile;
  },

  async updateLastSignedIn(userId: string): Promise<void> {
    await supabase
      .from('profiles')
      .update({ last_signed_in_at: new Date().toISOString() })
      .eq('id', userId);
  },
};
